import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import lightbox_user from 'lightbox_user.svg';

export default function LightboxCaption({ author, date, permalink }) {
  return (
    <section className="lightbox-caption">
      {author && (
        <Fragment>
          <div className="lightbox-user">
            <img
              data-src={lightbox_user}
              alt=""
              title="Lightbox User Icon"
              className="lazyload"
            />
            <span>Posted By {author}</span>
          </div>
          <span className="lightbox-date">{date}</span>
        </Fragment>
      )}
      {permalink && (
        <a
          aria-label="View instagram post"
          href={permalink}
          rel="noopener noreferrer"
          target="_blank"
          className="lightbox-date"
        >
          {permalink}
        </a>
      )}
    </section>
  );
}

LightboxCaption.propTypes = {
  author: PropTypes.string,
  date: PropTypes.string,
  permalink: PropTypes.string,
};
